import React from 'react'

export default function LogoSection() {
    return (
        <div id='logo-meaning' className="mt-6 text-center text-white px-4 mb-8">
          <div className="mt-2 max-w-3xl mx-auto">
            {/* صورة الشعار */}
            <img
              src="./Logo-section.png"  // هنا ضع مسار الصورة الخاصة بك
              alt="معنى الشعار"
              className="mx-auto" // لجعل الصورة تظهر في المنتصف
            />
          </div>
        </div>
      );
}
